import * as React from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import RoleSectionStore from '@src/pages/main/components/role-section/store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import cx from 'classnames';
import Link from '@src/components/link';
import Scenes from '@src/business-components/scene/index';

const RoleSection = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.rolePartRoot, store.isActive && styles.currentPage)}>
      <div className={styles.title} />
      <div className={styles.content}>
        <div className={styles.roleTabListWrap}>
          <div className={styles.roleTabList}>
            {store.roleMsgList.map((item, index) => {
              return (
                <Link className={cx(styles.roleItem, store.roleSwiper.activeIndex === index && styles.act)} key={index} onClick={() => store.changeRole(index)}>
                  <div className={cx(styles.roleIcon, styles.roleIconNormal)} style={{ backgroundImage: `url(${item.icon})` }} />
                  <div
                    className={cx(styles.roleIcon, styles.roleIconActive, store.roleSwiper.activeIndex === index && styles.roleIconActiveShow)}
                    style={{ backgroundImage: `url(${item.iconAct})` }}
                  />
                </Link>
              );
            })}
          </div>
        </div>

        <BaseSwiper store={store.roleSwiper}>
          {store.roleMsgList.map((item, index) => {
            return (
              <div className={cx(styles.roleItem)} key={index}>
                <div className={cx(styles.roleContent, store.isActive && store.roleSwiper.activeIndex === index && styles.roleContentAct)}>
                  <div className={styles.roleLabelBox}>
                    <div className={styles.roleLabel} style={{ backgroundImage: `url(${item.label})` }} />
                    <Link className={styles.videoBtn} onClick={() => store.pnClickPlayRoleVideo(item.rolePv)} />
                  </div>

                  <div
                    className={cx(styles.roleArms, store.isActive && store.roleSwiper.activeIndex === index && styles.roleArmsAct)}
                    style={{ backgroundImage: `url(${item.arms})` }}
                  />
                  <div className={cx(styles.roleGif, store.isActive && store.roleSwiper.activeIndex === index && styles.roleGifAct)}>
                    <Link className={styles.roleGifBorder} onClick={() => store.pnClickPlayRoleVideo(item.expandVideo)}>
                      <img src={item.gif} alt={''} />
                    </Link>
                  </div>
                </div>
                <div className={styles.roleImgBox}>
                  {/* 角色图片 */}
                  <div
                    className={cx(styles[`role${index + 1}`], store.isActive && store.roleSwiper.activeIndex === index && styles.roleImgAct)}
                    style={{ backgroundImage: `url(${item.roleImg})` }}
                  />
                  <div
                    className={cx(
                      styles.audioLine,
                      store.isActive && store.roleSwiper.activeIndex === index && styles.audioLineAct,
                      store.roleSwiper.activeIndex === 1 && styles.audioLineAct2
                    )}
                    style={{ backgroundImage: `url(${item.line})` }}
                  />
                  <Link
                    className={cx(
                      styles.audioBtn,
                      store.isActive && store.roleSwiper.activeIndex === index && styles.audioBtnAct,
                      store.roleSwiper.activeIndex === 1 && styles.audioBtnAct2
                    )}
                    onClick={() => store.onClickPlayRoleAudio(item.cvAudio)}
                  />
                </div>
              </div>
            );
          })}
        </BaseSwiper>
        <div className={styles.sceneWrapper}>
          <Scenes
            activeIndex={store.roleSwiper.activeIndex}
            isActive={store.isActive}
            SCENE_LIST={store.roleMsgList.map(item => ({
              type: 'image',
              src: require('./images/bg.jpg')
            }))}
            effectId={44}
            options={{
              transition: 'CrossZoom',
              duration: 1.5,
              delay: 0,
              ease: 'power1.inOut'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(RoleSection, RoleSectionStore);
